<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">

                    <v-row dense>
                        <v-col cols="12">
                            <span color="black" class="headline text-xs-center" v-text="`Datos Tasas`"></span>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Producto" color="textbox" v-model="obForm.producto"
                                 readonly outlined dense />
                        </v-col>
                        
                        <v-col cols="12" sm="4">
                            <v-autocomplete label="Cobertura *" color="textbox" v-model="obForm.idCobertura"
                                                :items="listGeneral.listCobertura" outlined dense 
                                                :rules="requeridoRegla" @change="onListar"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Póliza" color="textbox" v-model="obForm.poliza"
                                 readonly outlined dense />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col v-if="_.size(listGeneral.detalleTasa) == 0" cols="12" sm="6"/>
                        <v-col v-else cols="12" sm="6">
                            <v-btn rounded color="primary" dark @click="exportar('tableTasa','Tasas')">Exportar a XLSX</v-btn>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Buscar" color="textbox" v-model="obForm.busqueda" dense clearable prepend-inner-icon="search" />
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <v-data-table :search="obForm.busqueda" :headers="listGeneral.cabeceraTasa"
                                :items="listGeneral.detalleTasa" class="elevation-3" id="tableTasa">

                                <template v-slot:no-results>
                                    Tu búsqueda de "<span v-text="obForm.busqueda"></span>" no arrojó resultados.
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <v-row dense class="mt-3 mb-3" align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <v-icon color="secundary" class="btnNext" @click="siguiente">arrow_forward</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowDatosTasaComponent',
        inject:['siguiente','setData'],
        props: {
            listGeneral: {
                type: Object,
                default: {}
            },
            obModal: {
                type: Object,
                default: {}
            },
            active:{
                type:Boolean,
                default:false
            }
        },
        data: ()=>({
            cabecera:[
                {text:'Cobertura', value:'cobertura',class:'caption text-xs-center active'},
				{text:'Rango Año', value:'rangoAnio' ,class:'caption text-xs-center' },
				{text:'Rango Edad', value:'rangoEdad', class:'caption text-xs-center' },
				{text:'Tipo Vehículo', value:'tipoVehiculo' ,class:'caption text-xs-center' },
				{text:'Sexo', value:'genero' ,class:'caption text-xs-center' },
				{text:'Rango Valor', value:'rangoValor',class:'caption text-xs-center' },
				{text:'Valor', value:'porcentaje',class:'caption text-xs-center' },
				{text:'Estado', value:'estado',class:'caption text-xs-center' }
            ],
            obForm:{
                busqueda:''
            }
        }),
        created(){
            this.setData('listGeneral.cabeceraTasa',this.cabecera,false);
            this.obForm = {
                busqueda:'',
                idProducto:this.obModal.idProducto,
                producto:this.obModal.producto,
                poliza:this.obModal.poliza,
                idCobertura:null
            };
            this.onListarCobertura('L');
        },
        watch:{
            active(val){
                if(val && _.size(this.listGeneral.detalleTasa) == 0){
                    this.obForm = {
                        busqueda:'',
                        idProducto:this.obModal.idProducto,
                        producto:this.obModal.producto,
                        poliza:this.obModal.poliza,
                        idCobertura:null
                    };
                    this.setData('listGeneral.cabeceraTasa',this.cabecera,false);
                    this.onListarCobertura('L');
                }
            }
        },
        methods:{
            onListarCobertura(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    var o = _.merge(
                                        {opcion: 'COBERTURAS_X_PRODUCTO'},
                                        _.pick(this.obForm,['idProducto'])
                                    );

                    this.setData('listGeneral.listCobertura',[],false);
                    axios.post(`${BASE_URI}administrador/planCobertura/listar`,o)
                        .then((r) =>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                var l = _.cloneDeep(r.data.data);
                                l = _.map(l,(v)=>{  return { text:v.cobertura, value:v.id_cobertura}  });
                                this.setData('listGeneral.listCobertura',l,false);
                                this.$forceUpdate();
                        })
                        .catch((e) =>{
                                mensajesAlerta(e, error);
                        });
                }
            },
            onListar(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    var o = _.merge(
                                        {opcion: 'LISTAR_TASAS_CON'},
                                        _.pick(this.obForm,['idCobertura','idProducto'])
                                    );

                    this.setData('listGeneral.detalleTasa',[],false);
                    axios.post(`${BASE_URI}administrador/tasa-vehiculo/listar`,o)
                        .then((r) =>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                this.setData('listGeneral.detalleTasa',r.data.data,false);
                                this.$forceUpdate();
                        })
                        .catch((e) =>{
                                mensajesAlerta(e, error);
                        });
                }
            }
        }
    }
</script>
